// Definiciones globales
export const server_url = "http://localhost:5000"
export const max_categories = 5
export const use_timer = true
export const base_timer = 1000
export const category_colors = ["steelblue", "crimson", "forestgreen", "goldenrod", "purple"]
// network 
export const width = 500
export const xcenter = width / 2
export const height = 650
export const layer_sep = 200
export const unit_sep = [90, 90, 110]
export const xpos = [-1, 0, 1].map((x, k) => x * layer_sep + xcenter)
export const im_height = 100
